import { render, staticRenderFns } from "./GiftForm.vue?vue&type=template&id=3022dfc3"
import script from "./GiftForm.vue?vue&type=script&lang=js"
export * from "./GiftForm.vue?vue&type=script&lang=js"
import style0 from "./GiftForm.vue?vue&type=style&index=0&id=3022dfc3&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3022dfc3')) {
      api.createRecord('3022dfc3', component.options)
    } else {
      api.reload('3022dfc3', component.options)
    }
    module.hot.accept("./GiftForm.vue?vue&type=template&id=3022dfc3", function () {
      api.rerender('3022dfc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/components/GiftForm.vue"
export default component.exports